import App from './App.svelte';
import { mount } from "svelte";

const app = mount(App, {
	target: document.getElementById("app"),
	props: {
    // items: [],
    categories: [],
    object1137: {},
    object1138: {},
    object1139: {},
    cats1137: [],
    cats1138: [],
    cats1139: []
  }
});

export default app;